// @ts-expect-error $TSFixMeError: Could not find a declaration file for module 'redux-localstorage'. '/home/pedro/projects/mews-js/node_modules/redux-loca...
import persistState, { mergePersistedState } from 'redux-localstorage';

// @ts-expect-error $TSFixMeError: Could not find a declaration file for module 'redux-localstorage-filter'. '/home/pedro/projects/mews-js/node_modules/red...
import filter, { getSubset } from 'redux-localstorage-filter';

// @ts-expect-error $TSFixMeError: Could not find a declaration file for module 'redux-localstorage/lib/adapters/localStorage'. '/home/pedro/projects/mews-...
import adapter from 'redux-localstorage/lib/adapters/localStorage';
import { LOCAL_STORAGE_KEY } from '../modules/app/constants';
import { MODULE_NAME as dashboardName } from '../modules/dashboard';
import { MODULE_NAME as notificationKey } from '../modules/notifications';
import { MODULE_NAME as powerBiName } from '../modules/powerBi';
import preferences from '../modules/preferences';
import { TIMELINE_VIEW_NAME as timelineViewName } from '../modules/timeline';

const STORE_FILTERS = [
    `${dashboardName}.serviceSelection`,
    `${notificationKey}.knownNotifications`,
    preferences.moduleName,
    `${powerBiName}.bookmarks`,
    `${timelineViewName}.selectedDensity`,
    `${timelineViewName}.selectedDensityPercentage`,
    `${timelineViewName}.selectedTimeUnit`,
];

const storage = filter(STORE_FILTERS)(adapter(window.localStorage));

export default persistState(storage, LOCAL_STORAGE_KEY);

// @ts-expect-error $TSFixMeError: Parameter 'initialState' implicitly has an 'any' type.
const mergeWithFilteredPersistedState = (initialState, persistedState) => ({
    ...initialState,
    ...getSubset(persistedState, STORE_FILTERS),
});

export const mergeFilteredPersistedState = mergePersistedState(mergeWithFilteredPersistedState);
